import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaSearch, FaTimes, FaBars } from "react-icons/fa";
import logoCN from "./logo.svg";
import "./NavbarShared.css";
import "./NavbarDesktop.css";
import "./NavbarTablet.css";
import "./NavbarMobile.css";
import searchData from "../../data/searchData.json";

const Navbar = ({ customStyle }) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);
  const navigate = useNavigate();

  const toggleSearch = () => {
    if (showMobileMenu) {
      setShowMobileMenu(false);
      setShowOverlay(false);
    }
    setShowSearch(!showSearch);
    if (showSearch) {
      setSearchQuery("");
      setSearchResults([]);
    }
  };

  const toggleMobileMenu = () => {
    if (showSearch) {
      setShowSearch(false);
      setSearchQuery("");
      setSearchResults([]);
    }
    const newState = !showMobileMenu;
    setShowMobileMenu(newState);
    setShowOverlay(newState);
  };

  const closeMobileMenu = () => {
    setShowMobileMenu(false);
    setShowOverlay(false);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    console.log("Buscando:", searchQuery);
  };

  const handleResultClick = (path) => {
    navigate(path);
    setShowSearch(false);
    setSearchQuery("");
    setSearchResults([]);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() === "") {
      setSearchResults([]);
      return;
    }

    const results = searchData.filter(item =>
      item.content.toLowerCase().includes(query.toLowerCase()) ||
      item.title.toLowerCase().includes(query.toLowerCase())
    );

    setSearchResults(results);
  };

  return (
    
      <nav className={`navbar ${customStyle ? customStyle : ''}`}>
        <div className="navbar-content">
          <div className="navbar-left">
            <img src={logoCN} alt="Logo" className="logo" />
          </div>

          <ul className="navbar-right">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/cngroup">CNgroup</Link></li>
            <li><Link to="/servicios">Servicios</Link></li>
            <li><Link to="/clientes">Proyectos</Link></li>
            <li><Link to="/contacto">Contacto</Link></li>
          </ul>
          </div>

          <div className="desktop-search-button">
            <button
              className="search-button"
              onClick={toggleSearch}
              aria-label={showSearch ? "Cerrar búsqueda" : "Abrir búsqueda"}
            >
              {showSearch ? <FaTimes /> : <FaSearch />}
            </button>
          </div>
        
      

      {/* Controles móviles - ahora fuera de la barra principal */}
      <div className="mobile-controls-container">
        <div className="mobile-controls">
          <button
            className="search-button-mobile"
            onClick={toggleSearch}
            aria-label={showSearch ? "Cerrar búsqueda" : "Abrir búsqueda"}
          >
            {showSearch ? <FaTimes /> : <FaSearch />}
          </button>
          <button
            className="mobile-menu-button"
            onClick={toggleMobileMenu}
            aria-label="Menú de navegación"
          >
            <FaBars />
          </button>
       </div>
       </div>
      

      {/* Overlay */}
      {showOverlay && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}

      {/* Menú móvil */}
      {showMobileMenu && (
        <ul className="navbar-right mobile-menu-active">
          <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
          <li><Link to="/cngroup" onClick={closeMobileMenu}>CNgroup</Link></li>
          <li><Link to="/servicios" onClick={closeMobileMenu}>Servicios</Link></li>
          <li><Link to="/clientes" onClick={closeMobileMenu}>Proyectos</Link></li>
          <li><Link to="/contacto" onClick={closeMobileMenu}>Contacto</Link></li>
        </ul>
      )}

      {/* Barra de búsqueda */}
      {showSearch && (
        <div className="search-bar-below">
          <form onSubmit={handleSearchSubmit} className="search-form-below">
            <input
              type="text"
              placeholder="¿Qué estás buscando...?"
              value={searchQuery}
              onChange={handleSearchChange}
              className="search-input-below"
              autoFocus
            />
          </form>

          {searchResults.length > 0 && (
            <div className="search-results">
              {searchResults.map((result, index) => (
                <div
                  key={index}
                  className="search-result-item"
                  onClick={() => handleResultClick(result.path)}
                >
                  <div className="search-result-title">{result.title}</div>
                  <div className="search-result-content">
                    {result.content.substring(0, 100)}...
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;